import { render } from "./CreateProfile.vue?vue&type=template&id=610f4ac6&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"

import "./CreateProfile.vue?vue&type=style&index=0&id=610f4ac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610f4ac6"]])

export default __exports__